export default __webpack_public_path__ + "static/media/Logo_KR_Intro1.02b65f1b.png";